/**
 * Some constants that can be used inside the wpcheck advisor.
 */
export class WpcheckConstants {
  // form inputs
  static readonly FORM_FLOOR_MAX_MFH = 20;
  static readonly FORM_FLOOR_MIN_MFH = 2;
  static readonly FORM_FLOOR_MAX_EFH = 5;
  static readonly FORM_FLOOR_MIN_EFH = 1;
  static readonly FORM_VORLAUFTEMPERATUR_MIN = 30;
  static readonly FORM_VORLAUFTEMPERATUR_MAX = 75;
}
